<template>
<div>
  <v-row>
    <v-col class="pt-0">
      <v-card flat class="d-flex flex-column justify-space-between" min-height="65vh" height="75vh">
        <v-simple-table class="overflow-y-auto">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Quitar</th>
                <th class="text-left">N°</th>
                <th class="text-left">Concepto</th>
                <th class="text-left">Cantidad</th>
                <th class="text-right">Precio</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              <BillItemTr v-for="(item, index)  in billItems" :key="item.codigo" :item="item" :idx="index+1"/>
            </tbody>
          </template>
        </v-simple-table>
        <div>
          <v-divider />
          <v-row no-gutters @mouseenter="showWarning" @mouseleave="hideWarning">
            <v-col cols="3" >
              <v-chip class="mt-3 ml-3 mr-3" color="primary">TOTAL: ${{billSum}}</v-chip>
            </v-col>
            <v-col cols="7" offset-md="2">
              <template v-if="(!saleIsValid && !warn) || saleIsValid">
                <v-btn 
                  class="mt-3 mr-3" 
                  rounded 
                  small 
                  color="default"
                  :disabled="!saleIsValid"
                  @click="saveBill({type: 'pendiente', name: 'Pagar al recoger'})"
                >
                Pago Pendiente
                </v-btn>
                <v-btn 
                  class="mt-3" 
                  rounded 
                  small 
                  color="success"
                  :disabled="!saleIsValid"
                  @click="saveBill({type: 'cobrar', name: 'Cobrar Servicio'})"
                >
                Cobrar Ahora
                </v-btn>
              </template>
              <template v-else-if="!saleIsValid && warn">
                <v-alert
                  class="mt-2 mb-0" 
                  dense
                  outlined
                  :type="billNotValidErrorType"
                  max-width="90%"
                >
                  {{ billNotValidMessage }}
                </v-alert>
              </template>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-col>
  </v-row>
  <SaveNewBillModal  @close="hideModal"/>
</div>
</template>

<script>
import BillItemTr from './BillItemTr';
import SaveNewBillModal from './SaveNewBillModal';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'Bill',
  data: function(){
    return {
      openModal: false,
      warning: false,
    };
  },
  components: {
    BillItemTr,
    SaveNewBillModal
  },
  computed: {
    ...mapGetters(['billItems', 'billSum', 'billIsValid', 'billClientData']),
    saleIsValid(){
      if( this.billHasItems() && this.billHasClientData()) this.setBillValidStatus(true);
      else this.setBillValidStatus(false);
      return this.billIsValid;
    },
    billNotValidMessage(){
      if(!this.billHasItems() && this.billHasClientData())
        return "Por favor agrega items.";
      else if(!this.billHasClientData() && this.billHasItems())
        return "Por favor elige cliente."
      return "Agrega cliente e items.";
    },
    billNotValidErrorType(){
      if(!this.billHasItems() && !this.billHasClientData())
        return "info";
      return "error";
    },
    warn: {
      get: function(){ return this.warning; },
      set: function(newVal){ this.warning = newVal; }
    }
  },
  methods: {
    ...mapActions(['toggleBillModal', 'setBillPaymentStatus', 'setBillValidStatus']),
    billHasClientData(){ return (this.billClientData && this.billClientData.id) ? true : false; },
    billHasItems(){ return this.billItems.length > 0; },
    saveBill(paymentStatus){
      this.setBillPaymentStatus(paymentStatus);
      this.toggleBillModal(true);
    },
    hideModal(){ this.toggleBillModal(false); },
    showWarning(){ this.warn = true; },
    hideWarning(){ this.warn = false; }
  }
}
</script>